import { Navigate, useLocation } from 'react-router-dom';
import { getToken } from '../services/AuthService';
import permissions from './config/routePermissions';

const PrivateRoute = ({ element }) => {
  const location = useLocation();
  const token = getToken();

  if (!token) {
    sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
    return <Navigate to="/login" />;
  }

  const match = permissions.find(r => {
    const routePattern = r.path.replace(/:\w+/g, '[^/]+');
    const regex = new RegExp(`^${routePattern}$`);
    return regex.test(location.pathname);
  });
  if (match && match.roles.length > 0 && !match.roles.some(fn => fn())) {
    return <Navigate to="/" />;
  }

  return element;
};

export default PrivateRoute;
